export class SelfPasswordChange {
  Old_Password: string;
  New_Password: string;
}
